export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/threshold/sturges.js
// module id = 109
// module chunks = 0 1 2 3 4